import React, { useEffect, useRef, useState } from 'react';
import warning from '../../../assets/svg/icons/Warning.svg';
import Dots from '../../../assets/images/Dots.svg';
import ActiveDots from '../../../assets/images/active-dots.svg';
import { Api } from '../../../api';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { taskFeatureList } from '../../../utils/constants';
import toast from 'react-hot-toast';
import Loader from '../../../component/common/Loader';

const ChallengePreview = ({ handlePageChange }) => {
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);

  console.log(state); // { from: 'dashboard', customData: 123 }
  const [deatils, setDetails] = useState({});
  const [tasks, setTasks] = useState([]);

  const convertBackendTasks = (badge) => {
    // Get the tasks of the selected badge
    // const badge = badgeList.find(item => item._id === badgeId);
    if (!badge) return [];

    // console.log(badge,"badgebadgebadge")
    const backendTasks = badge || [];

    const groupedTasks = [];

    backendTasks.forEach((task) => {
      const matchedFeature = taskFeatureList.find((item) => item.backendName === task.feature);
      if (!matchedFeature) return;

      const group = matchedFeature.groubedBy;

      const subTask = {
        id: task._id,
        title: task.title,
        description: task.description,
        instruction: task.instruction,
        number_of_tries: task.number_of_tries,
        backend_name: task.feature,
        feature: matchedFeature.name,
        status: task.status,
        type_of_task: task.type_of_task,
        duration: task.duration,
        wellpoints: task.wellpoints
      };

      const existingGroup = groupedTasks.find((g) => g.grouped_by === group);
      if (existingGroup) {
        existingGroup.sub_tasks.push(subTask);
      } else {
        groupedTasks.push({
          id: group + '_' + Date.now(), // more readable unique ID
          grouped_by: group,
          sub_tasks: [subTask]
        });
      }
    });

    return {
      tasks: groupedTasks
    };
  };
  const handleDelete = (id) => {
    setTasks((prev) => prev.filter((task) => task.id !== id));
  };
  const TaskCard = ({ task, onDelete }) => {
    const [cardId, setCardId] = useState(null);
    const popupRef = useRef(null);
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
          setCardId(null);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [popupRef]);

    const handleButtonClick = () => {
      setCardId((prev) => (prev === task.id ? null : task.id)); // toggle or open new
    };

    return (
      <div
        className="gap-4 mt-4 p-3
               bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl"
      >
        {/* Card Header */}
        <div className="flex gap-4">
          <div className="flex-1">
            <div className="flex justify-between items-start mb-3">
              <h2 className="font-medium text-gray-800 flex items-center gap-2">
                {task.grouped_by}
                <img id={task.id} src={warning} alt="Warning" className="w-6 h-6 cursor-pointer" />
                <Tooltip
                  anchorSelect={`#${task.id}`}
                  place="top"
                  content={task.msg}
                  className="max-w-xs break-words z-50"
                  style={{ zIndex: 9999 }}
                />
              </h2>

              <div className="relative" ref={popupRef}>
                <button onClick={handleButtonClick}>
                  <img src={Dots} alt="Menu" className="w-6 h-6 block dark:hidden" />
                  <img src={ActiveDots} alt="Menu Active" className="w-6 h-6 hidden dark:block" />
                </button>

                {cardId === task.id && (
                  <div
                    className="w-35 z-50 bg-white dark:bg-shoorah-darkBgTabColor absolute top-4 right-0 mt-2 
                                       border-[1.5px] rounded-lg shadow-lg"
                  >
                    <div
                      className="py-2 px-5 hover:bg-gray-100 cursor-pointer text-red-700 font-medium"
                      onClick={() => {
                        onDelete(task.id);
                        setCardId(null);
                      }}
                    >
                      Delete
                    </div>
                  </div>
                )}
              </div>
            </div>

            {task?.sub_tasks?.length > 0 &&
              task?.sub_tasks?.map((t, i) => (
                <div
                  key={i}
                  className="bg-[#F4F5F6] px-4 py-3 rounded-lg mb-2 border border-gray-100"
                >
                  <p className="font-medium text-gray-800">{t.title}</p>
                  <p className="text-sm text-gray-500">{t.description}</p>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  };
  const fetchList = async (id) => {
    try {
        setLoader(true);
      await Api.getSpecificChallenges(id).then((response) => {
        const responseData = response?.data || {};
        if (responseData) {
          const taskModify = convertBackendTasks(responseData?.tasks);
          setTasks(taskModify?.tasks || []);
          setDetails(responseData);
        }
      });
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
        setLoader(false);
    }
  };

  useEffect(() => {
    if (state?._id) {
      fetchList(state?._id);
    }
  }, [state?._id]);

  const handleFinalSubmit = async (statusID) => {
    try {
      setLoader(true);
      const body = {};
      // body.badge_level = propsData.formData.badge_level;
      body.status = statusID;
      body.challengeId = state?._id;
      const flatTasks =
        tasks?.flatMap((group) =>
          group.sub_tasks.map((task) => ({
            ...task,
            // status: 'published',
            feature: task?.backend_name
          }))
        ) || [];

      if (flatTasks.length > 0) {
        body.tasks = flatTasks;
      } else {
        body.tasks = [];
      }
      // API call
      const response = await Api.updateChallengesStatus(body);

      if (response?.status === 200) {
        toast.success(response?.data?.message);
        navigate('/challenges');
      }
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
      setLoader(false);
    }
  };
  return (
    <div className="relative lg:pl-5 lg:mb-[45px]">
      {loader ? <Loader /> : null}
      <div className="flex justify-between items-center gap-2">
        <h3 className="font-medium text-xl">Preview</h3>
        <div className="ml-3 self-center">
          <button
            className="text-sm px-5 py-2 lg:rounded-2xl rounded-xl border border-[#0B1D2E] bg-[#f4f4f4] text-[#0B1D2E]"
            onClick={() => {
            //   setData((prev) => ({ ...prev, tasks: tasks }));
              handlePageChange('details');
            }}
          >
            Edit Challenge
          </button>
        </div>
      </div>
      <div className="max-w-[900px] p-[15px] mt-[15px] bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
        <div className="w-full p-[15px] bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
          <h3 className="font-[500] text-[16px]">Mindfulness weekend </h3>
          <div className="w-full p-[10px] flex items-center mt-2 bg-white dark:bg-shoorah-darkBgTabColor dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
            <img className="mr-2 h-[32px] w-[32px]" src={deatils?.image} alt="" />
            <p className="font-medium text-gray-800">
              {deatils?.title || 'Qualify for a £100 Amazon gift card'}
            </p>
          </div>
          <div className="flex items-center mt-2 bg-[#F4F5F6] p-[10px]   dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
            <p className="font-medium text-gray-800">{`Duration - ${deatils?.duration}`}</p>
          </div>
          <div className="bg-[#F4F5F6] p-[10px]  mt-2 dark:border-none border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl">
            <p className="font-medium text-gray-800">
              {deatils?.challenge_title || 'About the challenge'}
            </p>
            <p className="text-sm text-gray-500 mt-2">
              {deatils?.description ||
                'Once you’ve completed the required challenges, your £10 M&S gift voucher will be available to view directly in the Shoorah app. You can use it in-store or online. Just open the app to access your voucher!'}
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1">
        <div className="grid grid-cols-1 max-w-[900px]">
          {tasks?.length > 0 &&
            tasks?.map((task, index) => (
              <TaskCard key={index} task={task} onDelete={handleDelete} />
            ))}
        </div>
      </div>
      <div className="flex justify-end mt-6">
        <div className="mr-3 self-center">
          <button
            type="button"
            onClick={() => {
              handleFinalSubmit(0);
            }}
            className="text-sm px-5 h-[40px] lg:rounded-2xl rounded-xl border border-[#0B1D2E] bg-[#f4f4f4] text-[#0B1D2E]"
          >
            Save as Template
          </button>
        </div>
        <button
          type="button"
          onClick={() => {
            handleFinalSubmit(1);
          }}
          className="inline-flex text-xs sm:text-base font-medium items-center justify-center lg:rounded-2xl rounded-xl border bg-shoorah-secondary px-5 py-2 text-white hover:shoorah-primary focus:outline-none w-full sm:w-auto"
        >
          Publish Challenge
          {/* <img className="ml-2" src={RightArrow} alt="edit" /> */}
        </button>
      </div>
    </div>
  );
};

export default ChallengePreview;
